import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { localStorageToken,authStorage } from "../utils/variables";

export const useStoreMasterData = () => {
  return useQuery({
    queryKey: ["storeMasterData"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/store-master`
      );

      if (data.code === 200) return data.data;
    },
    refetchOnWindowFocus: false,
  });
};

export const useStoreDetails = (storeId, isEnabled) => {
  return useQuery({
    queryKey: ["storeDetails", storeId],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${storeId}`
        // {
        //   headers: {
        //     Authorization: `Bearer ${token}`, // Removed because api giving error after some time of session
        //   },
        // }
      );

      if (data.code === 200) return data.data;
    },
    enabled: isEnabled,
    refetchOnWindowFocus: false,
  });
};

export const useStoreThemeData = (storeId) => {
  return useQuery({
    queryKey: ["storeThemeData", storeId],
    queryFn: async () => {
      const { data } = await axios(
        `${process.env.REACT_APP_STORE_LOCATION_API}/sys-config/store/${storeId}`
      );

      const lastData = data.data.data;

      const dataObj = {
        ...lastData,
        data: JSON.parse(decodeURI(lastData.data)),
      };

      return dataObj;
    },
    enabled: !!storeId,
    refetchOnWindowFocus: false,
  });
};
